module.exports = __webpack_public_path__ + "img/KN.9b7427b8.svg";